import { Pagination } from "services/search";
import { ActivityLogRow } from "./types";
import { DataWithPagination } from "services/api/types";
import { paginatedApiCall } from "services/api/createApiCall";
import { transformActivityLogRow } from "./transformations";

export const getVehicleActivityLogsAPI = async (
  pagination: Pagination,
  vehicleId: string
): Promise<DataWithPagination<ActivityLogRow>> => {
  const path = `/v1/fleet/activitylogs?entityGroup=Vehicle&entityGroupId=${vehicleId}`;

  return await paginatedApiCall(path, pagination, transformActivityLogRow);
};

/**
 * Dnevnik aktivnosti (svi entiteti) — za tenant/detaljni pregled.
 * NAPOMENA: backend trenutno filtrira po tenantu prijavljenog korisnika;
 * `tenantId` se šalje za buduću super-user podršku (kad backend to prihvati).
 */
export const getActivityLogsAPI = async (
  pagination: Pagination,
  filters?: { tenantId?: string | null }
): Promise<DataWithPagination<ActivityLogRow>> => {
  let path = `/v1/fleet/activitylogs?`;
  if (filters?.tenantId) path += `tenantId=${encodeURIComponent(filters.tenantId)}&`;

  return await paginatedApiCall(path, pagination, transformActivityLogRow);
};
